var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewLogoGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 17,
    viewBox: "0 0 96 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_768_1009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6718 0.455961C18.4361 -0.660827 15.4943 0.339087 13.1791 2.72561C12.7232 1.72137 12.0171 0.927782 11.0728 0.455961C8.04428 -1.05762 3.71842 1.31592 1.41061 5.75854C-0.897201 10.2012 -0.311791 15.029 2.71675 16.5441C4.95249 17.6609 7.89426 16.6609 10.2094 14.2744C10.6654 15.2787 11.3714 16.0722 12.3157 16.5441C15.3443 18.0576 19.6701 15.6841 21.9779 11.2415C24.2858 6.79886 23.7003 1.97098 20.6718 0.455961Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7384 1.0376C48.3464 1.0376 44.7869 4.52936 44.7869 8.8378C44.7869 13.1462 48.3464 16.638 52.7384 16.638C57.1305 16.638 60.69 13.1462 60.69 8.8378C60.69 4.52936 57.1305 1.0376 52.7384 1.0376ZM52.7384 13.178C50.2953 13.178 48.314 11.2344 48.314 8.8378C48.314 6.44118 50.2953 4.49762 52.7384 4.49762C55.1816 4.49762 57.1629 6.44118 57.1629 8.8378C57.1629 11.2344 55.1816 13.178 52.7384 13.178Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0483 1.0376C83.6562 1.0376 80.0967 4.52936 80.0967 8.8378C80.0967 13.1462 83.6562 16.638 88.0483 16.638C92.4403 16.638 95.9998 13.1462 95.9998 8.8378C95.9998 4.52936 92.4403 1.0376 88.0483 1.0376ZM88.0483 13.178C85.6051 13.178 83.6239 11.2344 83.6239 8.8378C83.6239 6.44118 85.6051 4.49762 88.0483 4.49762C90.4914 4.49762 92.4727 6.44118 92.4727 8.8378C92.4727 11.2344 90.4914 13.178 88.0483 13.178Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9759 10.8751H74.6634C74.6634 10.8751 74.4678 11.4176 74.1221 11.8736C73.4132 12.81 72.2865 13.2861 70.7715 13.2861C67.5561 13.2861 66.1176 11.0699 66.1176 8.87382C66.1176 6.33003 67.9724 4.48314 70.5258 4.48314C71.8143 4.48314 72.969 4.92466 73.722 5.69949L76.7682 3.97381C75.3371 2.15001 73.0057 1.06641 70.4817 1.06641C66.044 1.06641 62.5684 4.48603 62.5684 8.85218C62.5684 13.2183 66.0661 16.5932 70.7053 16.5932C73.5558 16.5932 75.9225 15.3581 77.2007 13.2053C77.7949 12.204 78.1332 11.0468 78.2038 9.76552C78.2141 9.57795 78.2185 9.41923 78.2185 9.26629V7.91864H70.9774V10.8765L70.9759 10.8751Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9233 10.8937L31.543 1.79639H27.3716L34.5068 15.8601H37.3618L44.4956 1.79639H40.3256L35.9233 10.8937Z",
    fill: "#888888"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_768_1009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogoGray);
export default __webpack_public_path__ + "static/media/new_logo_gray.8c0f637b374f26bf42b4c4e1751a5ef5.svg";
export { ForwardRef as ReactComponent };